import {Card} from 'antd'

export const FormCard = ({children, ...props}) => {
    return <Card {...props}
                 styles={{header: {borderBottom: 'none'}, body: {paddingTop: 4, paddingBottom: 4}}}
                 style={{marginBottom: 10}}>{children}</Card>
}